import { devConfig } from "../Utils/configs/DEV";
import { prodConfig } from "../Utils/configs/PROD";

export const KEY_AZURE_TOKEN = "azure_token";
export const KEY_ACCESS_TOKEN = "access_token";
export const KEY_REFRESH_TOKEN = "refresh_token";
export const KEY_CONFIG_URL = "https://config-api.ken42.com/v1/configs/url";
export const REFRESH_URL = "https://smu-prod-api.ken42.com/api/app/refreshToken";
export const COUNTRIES_API_KEY = "aDZEc2VEaEpiaHA2WUlhVXhOdndBejI2ZXVjdnFydUozWHJFWlBQcA==";
export const COUNTRIES_BASE_URL = "https://api.countrystatecity.in/";
export const SENTRY_DSN = "https://a57ef6263b5fbcb7ea59639eac3c758d@o4506744673861632.ingest.us.sentry.io/4508800153747456";
export const MIXPANEL_PROJECTID = "5a872ff78268eefe80ea3356cee66ce7";
export const REGEX = {
  NAME: /^[a-zA-Z ]*$/,
  MOBILE: /^(\+\d{1,3}[- ]?)?\d{10}$/,
  PINCODE: /^[0-9]{6,6}$/,
  NUMBER: /[^0-9]/,
  ONLYNUMBER: /^[0-9]*$/,
  NUMBERWITHDECIMAL: /^[0-9]+(?:\.[0-9]+)?$/,
  ANNUALINCOME: /^(?!0)\d*(\.\d+)?$/,
  DIGITS_ONLY_UPTO_100: /^\-?(([0-9]\d?|0\d{1,2})((\.)\d{0,2})?|100((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_10: /^\-?((0\d|\d)?((\.)\d{0,2})?|10((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_4: /^\-?((0[0-3]|[0-3])?((\.)\d{0,2})?|(4|04)((\.)0{1,2})?)$/,
  PERCENTAGE: /^100$/,
  DECIMAL: /^(\d*\.)?\d+$/,
  ALPHANUMBERIC: /^[a-zA-Z0-9]+$/,
  CGPA: /^10$/,
  GRADE2: /^[A-D][1-9]?(\+{1,2})?$/,
  GST: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  PAN: /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/,
  GRADE: /^[a-fA-FOoPp]$/,
  MIXED: /^[a-zA-Z0-9&-./, ]*$/,
  MIXED_ADDRESS: /^[a-zA-Z0-9-.#/, ]*$/,
  PARENT_DOC: /^aadhaarParent/,
  PHONE_NUMBER: /^[0-9]*$/,
  AADHAAR: "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$",
  AlphaSpecial: /^[A-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]*$/i,
  LINKEDIN: /^https?:\/\/((www|\w\w)\.)?linkedin\.com\/((in\/[^\/]+\/?)|(pub\/[^\/]+\/((\w|\d)+\/?){3}))/gm,
  TWITTER: /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/,
  CHEQUE: /^\d{6}$/,
  HTTPS: /^(https?:\/\/www\.|https?:\/\/|www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+)(\/[^\s]*)?$/,
  EMAIL: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/,
  NEET: /^[A-Za-z]{2}\d{8}$/,
  NEETROLLNUMBER: /^PG\d{8}$/,
  SCHOOLNAME: /^[a-zA-Z0-9',.\-\s]+$/,
  SCHOOLNAME: /^[a-zA-Z0-9',.\-\s]+$/,
  LASTNAME: /^[a-zA-Z\s]+\.?$/,
  //   EMAIL:
  //     /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

const data = {
  DEV: devConfig,
  PROD: prodConfig,
};
export const CONFIGS = data["DEV"];

export const COUNSELLING_ROUND_VALIDATIONS = {
  "MD/MS": {
    enableNeetEdit: false,
    "Round 1": {
      General: 276,
      Reserved: 235,
    },
    "Round 2": {
      General: 276,
      Reserved: 235,
    },
    "Round 3": {
      General: 50,
      Reserved: 0,
    },
    "Round 4": {
      General: 0,
      Reserved: 0,
    },
  },
  MBBS: {
    enableNeetEdit: false,
    "Round 1": {
      General: 144,
      Reserved: 113,
    },
    "Round 2": {
      General: 150,
      Reserved: 150,
    },
    "Round 3": {
      General: 250,
      Reserved: 250,
    },
  },
};

export const PREFERNCE_ORDER = {
  General: 1,
  Management: 2,
};
export const ROLES = { APPLICANT: "APPLICANT", PARTNER: "PARTNER" };
export const PERMISSIONS = {
  [ROLES.APPLICANT]: {
    APP_HOME: "APP_HOME",
    APP_APPLICATIONS: "APP_APPLICATIONS",
    APP_DOCUMENTS: "APP_DOCUMENTS",
    APP_THANKYOU: "APP_THANKYOU",
    APP_FEEPAYEMENTS: "APP_FEEPAYEMENTS",
    APP_COURSES: "APP_COURSES",
    APP_ONBOARDING: "APP_ONBOARDING",
    APP_FEEDETAILS: "APP_FEEDETAILS",
    APP_OFFERLETTERDETAILED: "APP_OFFERLETTERDETAILED",
    APP_INTERVIEWSLOTS: "APP_INTERVIEWSLOTS",
    APP_INTERVIEW: "APP_INTERVIEW",
    APP_OFFERLETTER: "APP_OFFERLETTER",
    APP_FEESTRUCTURE: "APP_FEESTRUCTURE",
    APP_HDFC: "APP_HDFC",
    APP_WITHDRAWAL: "APP_WITHDRAWAL",
  },
  [ROLES.PARTNER]: {
    PAR_HOME: "PAR_HOME",
    PAR_APPLICATIONS: "PAR_APPLICATIONS",
  },
};
export const TABLET_BREAKPOINT = "tablet";
export const MDMS_NEET_UPDATE_LIST = [
  "a0KF900002DZFKjMAP",
  "a0KF900002DZFKoMAP",
  "a0KF900002DZFKyMAP",
  "a0KF900002DZFLcMAP",
  "a0KF900002DZFfoMAH",
  "a0KF900002DZFfyMAH",
  "a0KF900002DZaa7MAD",
  "a0KF900002DZaaCMAT",
  "a0KF900002DZmziMAD",
  "a0KF900002DZocHMAT",
  "a0KF900002Da0omMAB",
  "a0KF900002Da0rgMAB",
  "a0KF900002Da2FkMAJ",
  "a0KF900002Da2G4MAJ",
  "a0KF900002Da2GOMAZ",
  "a0KF900002Da2GYMAZ",
  "a0KF900002Da2HbMAJ",
  "a0KF900002Da2ItMAJ",
  "a0KF900002Da2JDMAZ",
  "a0KF900002Da2KfMAJ",
  "a0KF900002Da2PMMAZ",
  "a0KF900002Da2RwMAJ",
  "a0KF900002Da2fbMAB",
  "a0KF900002Da2jPMAR",
  "a0KF900002Da2khMAB",
  "a0KF900002Da2taMAB",
  "a0KF900002Da4MTMAZ",
  "a0KF900002DaFffMAF",
  "a0KF900002DaFk1MAF",
  "a0Kfw000000aK1qEAE",
  "a0Kfw0000013szOEAQ",
  "a0Kfw000001464fEAA",
  "a0Kfw00000142lqEAA",
  "a0Kfw000001EoHJEA0",
  "a0Kfw000001HgzxEAC",
  "a0Kfw000001Lc9lEAC",
  "a0Kfw000001MIvNEAW",
  "a0Kfw000001MJRdEAO",
  "a0Kfw000001McUHEA0",
  "a0Kfw000001MlhFEAS",
  "a0Kfw000001NeVeEAK",
  "a0Kfw000001Nj2HEAS",
  "a0Kfw000001P4MPEA0",
  "a0Kfw000001PLK1EAO",
  "a0Kfw000001QdgHEAS",
  "a0Kfw000001RZ17EAG",
  "a0Kfw000001RcJxEAK",
  "a0Kfw000001SIe9EAG",
  "a0Kfw000001SZzxEAG",
  "a0Kfw000001SaMXEA0",
  "a0Kfw000001TBU9EAO",
  "a0Kfw000001TIfJEAW",
  "a0Kfw000001U169EAC",
  "a0Kfw000001U7OTEA0",
  "a0Kfw000001UL02EAG",
  "a0Kfw000001WMHlEAO",
  "a0Kfw000001WgQ9EAK",
  "a0Kfw000001Wf5uEAC",
  "a0Kfw000001X9K6EAK",
  "a0Kfw000001YCZFEA4",
  "a0Kfw000001ZQtVEAW",
  "a0Kfw000001aNS9EAM",
  "a0Kfw000001alCjEAI",
  "a0Kfw000001b5PyEAI",
  "a0Kfw000001brSzEAI",
  "a0Kfw000001c8vFEAQ",
  "a0Kfw000001eMKbEAM",
  "a0Kfw000001fKOnEAM",
  "a0Kfw000001hnL4EAI",
  "a0Kfw000001jo05EAA",
  "a0Kfw000001kV0DEAU",
  "a0Kfw000001ktPKEAY",
  "a0Kfw000001lGC1EAM",
  "a0Kfw000001lYIbEAM",
  "a0Kfw000001nxeHEAQ",
  "a0Kfw000001o4B7EAI",
];
